import { NewCampaignState } from "@/services/new-campaign.service";
import { createStepCreator } from "../step-creator";

export type DeliveryStepperContext = Pick<
  NewCampaignState,
  "configurations" | "delivery"
>;

const stepCreator = createStepCreator<DeliveryStepperContext>();

const { baseSteps: baseDeliverySteps, createSteps: createDeliverySteps } =
  stepCreator.createBaseSteps([
    {
      id: "configure",
      name: "Vælg modtager",
      getIsVisible: (context) => context.delivery?.type === "Excel",
      getIsValid: ({ delivery }) => !!delivery?.completionEmail,
    },
    {
      id: "integration/select",
      name: "Vælg integration",
      getIsVisible: (context) => context.delivery?.type === "Integration",
      getIsValid: ({ delivery }) =>
        !!delivery && delivery?.exportSystem !== null,
    },
    {
      id: "integration/method",
      name: "Kvalificering",
      getIsVisible: (context) => context.delivery?.type === "Integration",
      getIsValid: ({ delivery }) => !!delivery && delivery?.exportMode !== null,
    },
    {
      id: "integration/configure",
      name: "Opsætning",
      getIsVisible: (context) => context.delivery?.type === "Integration",
      getIsValid: ({ delivery }) =>
        delivery?.type === "Integration" && delivery.exportInput !== null,
    },
  ]);

const { createSteps: createDeliverySetupSteps } = stepCreator.createBaseSteps([
  {
    id: "method",
    name: "Destination",
    getIsValid: (context) => !!context.delivery,
  },
  ...baseDeliverySteps,
]);

export { createDeliverySetupSteps, createDeliverySteps };
